import { FLOWCHART_UNDO_MAX_STACK } from './constants';
import { cloneCanvasSnapshot } from './cloneCanvasSnapshot';

export function createFlowchartUndoStack(maxSize = FLOWCHART_UNDO_MAX_STACK) {
  let past = [];
  let present = null;
  let future = [];

  const clone = (snapshot) => {
    if (!snapshot) return null;
    return cloneCanvasSnapshot(snapshot.nodes, snapshot.edges, snapshot.identifiedRisks);
  };

  return {
    reset(baseline) {
      past = [];
      future = [];
      present = baseline ? clone(baseline) : null;
    },

    hasPresent() {
      return present != null;
    },

    getPresent() {
      return present ? clone(present) : null;
    },

    canUndo() {
      return past.length > 0;
    },

    canRedo() {
      return future.length > 0;
    },

    // No-op when next equals present (keeps redo after Z/Y restore).
    commit(nextSnapshot) {
      if (!nextSnapshot) return;
      const next = clone(nextSnapshot);
      try {
        if (present && JSON.stringify(present) === JSON.stringify(next)) {
          return;
        }
      } catch {
        // continue with commit
      }
      if (present) {
        past.push(present);
        if (past.length > maxSize) {
          past.splice(0, past.length - maxSize);
        }
      }
      present = next;
      future = [];
    },

    replacePresent(nextSnapshot) {
      present = nextSnapshot ? clone(nextSnapshot) : null;
    },

    undo() {
      if (past.length === 0 || !present) return null;
      future.push(present);
      present = past.pop();
      return clone(present);
    },

    redo() {
      if (future.length === 0 || !present) return null;
      past.push(present);
      present = future.pop();
      return clone(present);
    },

    clear() {
      past = [];
      present = null;
      future = [];
    },
  };
}
